import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UiStateManagementService } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { DatePickerService } from '../../shared/utils/date-picker.service';
import { DropdownService } from '../../shared/utils/dropdown.service';
import { WidgetEventService } from '../../shared/utils/widget-event.service';
import {
  StaysWidget,
  StaysWidgetForm
} from '../models/stays-widget.interfaces';
import { InitializationService } from './initialization.service';

@Injectable({
  providedIn: 'root'
})
export class ComponentLifecycleHelperService {
  initService = inject(InitializationService);
  dateService = inject(DatePickerService);
  uiStateService = inject(UiStateManagementService);
  eventService = inject(WidgetEventService);
  dropdownService = inject(DropdownService);

  setDestinationError(
    form: FormGroup<StaysWidgetForm>,
    content: StaysWidget
  ): string {
    const isDestinationInvalid = form.controls['location'].invalid;
    return isDestinationInvalid ? content.labels.destinationErrorLabel : '';
  }

  setDateError(form: FormGroup<StaysWidgetForm>, content: StaysWidget): string {
    const isCheckInDateInvalid = form.controls['checkInDate'].invalid;
    const isCheckOutDateInvalid = form.controls['checkOutDate'].invalid;
    return isCheckInDateInvalid || isCheckOutDateInvalid
      ? content.labels.datesAreRequiredErrorLabel
      : '';
  }
}
